// ** React Imports
import { useNavigate, Link } from 'react-router-dom'

// ** MUI Imports
import Chip from '@mui/material/Chip'
import ListItem from '@mui/material/ListItem'
import { styled } from '@mui/material/styles'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemButton from '@mui/material/ListItemButton'

// ** Configs Import
import themeConfig from '../../../../components/configs/themeConfig'

// ** Custom Components Imports
import UserIcon from '../../../../components/layouts/components/UserIcon'
// import Translations from '../../../../components/layouts/components/Translations'
// import CanViewNavLink from '../../../../components/layouts/components/acl/CanViewNavLink'
import { useUnsavedChanges } from '../../../../components/UnsavedChangesContext'

// ** Util Imports
import { hexToRGBA } from '../../../../components/utils/hex-to-rgba'
// import { handleURLQueries } from '../../../../layouts/utils'

// ** Third Party Imports
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import NProgress from 'react-nprogress'
import { useEffect, useState } from 'react'
import UnsavedChangesDialog from 'components/UnsavedChangesDialog'

// ** Styled Components
const MenuNavLink = styled(ListItemButton)(({ theme }) => ({
  width: '100%',
  marginLeft: theme.spacing(3.5),
  marginRight: theme.spacing(3.5),
  borderRadius: theme.shape.borderRadius,
  transition: 'padding-left .25s ease-in-out, padding-right .25s ease-in-out',
  '&:hover': {
    backgroundColor: theme.palette.action.hover
  },
  '&.active': {
    '&, &:hover': {
      boxShadow: `0px 2px 6px ${hexToRGBA(theme.palette.btn.primary, 0.48)}`,
      background: `linear-gradient(72.47deg, ${
        theme.direction === 'ltr' ? theme.palette.btn.primary : hexToRGBA(theme.palette.btn.primary, 0.7)
      } 22.16%, ${
        theme.direction === 'ltr' ? hexToRGBA(theme.palette.btn.primary, 0.7) : theme.palette.btn.primary
      } 76.47%)`,
      '&.Mui-focusVisible': {
        background: `linear-gradient(72.47deg, ${theme.palette.primary.dark} 22.16%, ${hexToRGBA(
          theme.palette.primary.dark,
          0.7
        )} 76.47%)`
      }
    },
    '& .MuiTypography-root, & svg': {
      color: `${theme.palette.common.white} !important`
    }
  }
}))

const MenuItemTextMetaWrapper = styled(Box)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(2),
  justifyContent: 'space-between',
  transition: 'opacity .25s ease-in-out',
  ...(themeConfig.menuTextTruncate && { overflow: 'hidden' })
}))

const VerticalNavLink = ({
  item,
  parent,
  navHover,
  settings,
  navVisible,
  isSubToSub,
  collapsedNavWidth,
  toggleNavVisibility,
  navigationBorderWidth,
  activeLink
}) => {

  // ** Vars
  const { navCollapsed } = settings
  const icon = parent && !item.icon ? themeConfig.navSubItemIcon : item.icon
  const navigate = useNavigate();
  const { hasUnsavedChanges, setHasUnsavedChanges } = useUnsavedChanges();
  const MySwal = withReactContent(Swal);
  const [open, setOpen] = useState(false);

  const handleOpenDlg = () => setOpen(true);
    const handleCloseDlg = () => setOpen(false);
    const handleDiscard = () => {handleCloseDlg(); navigate(item.path); setHasUnsavedChanges(false);}

    // useEffect(() => {
    //   if (hasUnsavedChanges) {
      
    //     handleOpenDlg();
    //   }
    //   else{
    //     handleCloseDlg();
    //   } 
    // }
    // , [hasUnsavedChanges]);
  // const startLoader = (e) => {
  //   e.preventDefault();

  //   if (item.path === undefined) {
  //     return;
  //   }

  //   if (hasUnsavedChanges) {
  //     const confirmNavigation = window.confirm(
  //       'You have unsaved changes. Are you sure you want to leave this page?'
  //     );
  //     if (!confirmNavigation) {
  //       return;
  //     }else{
  //       setHasUnsavedChanges(false);
  //     }
  //   }
    
  //   if (navVisible) {
  //     toggleNavVisibility();
  //   }

  //   navigate(item.path);
  // }

  const startLoader = (e) => {
    e.preventDefault();

    if (item.path === undefined) {
      return;
    }

    if (hasUnsavedChanges) {
      handleOpenDlg();
      // MySwal.fire({
      //   title: "Are you sure?",
      //   html: "This page has unsaved changes",
      //   showCancelButton: true,
      //   confirmButtonColor: "#23A26D",
      //   cancelButtonColor: "#d33",
      //   confirmButtonText: "Discard Changes",
      //   cancelButtonText: "Cancel",
      //   allowEscapeKey: true,
      // }).then((result) => {
      //   if (result.isConfirmed) {
      //     navigate(item.path);
      //     setHasUnsavedChanges(false);
      //   }
      // });
    }else{
      if (navVisible) {
        toggleNavVisibility();
      }
  
      navigate(item.path);
    }
  }

  const isNavLinkActive = (title) => {
    return title === activeLink;
  }
  
  return (
    <>
      <ListItem
        disablePadding
        className='nav-link'
        disabled={item.disabled || false}
        sx={{ mt: 0.5, px: '0 !important',overflowY: 'auto' }}
      >
        <MenuNavLink
          component={Link}
          // {...(item.disabled && { tabIndex: -1 })}
          className={isNavLinkActive(item.title) ? 'active' : ''}
          // to={item.path === undefined ? '/' : `${item.path}`}
          {...(item.openInNewTab ? { target: '_blank' } : null)}
          onClick={startLoader}
          sx={{
            py: 1.8,
            ...(item.disabled ? { pointerEvents: 'none' } : { cursor: 'pointer' }),
            px: navCollapsed && !navHover ? (collapsedNavWidth - navigationBorderWidth - 22 - 28) / 8 : 4,
            '& .MuiTypography-root, & svg': {
              color: 'text.secondary'
            }
          }}
        >
          <ListItemIcon
            sx={{
              transition: 'margin .25s ease-in-out',
              ...(navCollapsed && !navHover ? { mr: 0 } : { mr: 2 }),
              ...(parent ? { ml: 1.5, mr: 3.5 } : {}),
              '& svg': {
                fontSize: '0.625rem',
                ...(!parent ? { fontSize: '1.375rem' } : {}),
                ...(parent && item.icon ? { fontSize: '0.875rem' } : {})
              }
            }}
          >
            <UserIcon icon={icon} />
          </ListItemIcon>

          <MenuItemTextMetaWrapper
            sx={{
              ...(isSubToSub ? { ml: 2 } : {}),
              ...(navCollapsed && !navHover ? { opacity: 0 } : { opacity: 1 })
            }}
          >
            <Typography
              {...((themeConfig.menuTextTruncate || (!themeConfig.menuTextTruncate && navCollapsed && !navHover)) && {
                noWrap: true
              })}
            >
              {item.title}
            </Typography>
            {item.badgeContent ? (
              <Chip
                size='small'
                label={item.badgeContent}
                color={item.badgeColor || 'primary'}
                sx={{ height: 22, minWidth: 22, '& .MuiChip-label': { px: 1.5, textTransform: 'capitalize' } }}
              />
            ) : null}
          </MenuItemTextMetaWrapper>
        </MenuNavLink>
      </ListItem>
      
      <UnsavedChangesDialog
        open={open}
        handleClose={handleCloseDlg}
        handleDiscard={handleDiscard}
        />
      </>
  )
}

export default VerticalNavLink
